import React, { useEffect, useState } from "react";
import DollarImg from "../../../assets/user/images/dollar.svg";
import CashImg from "../../../assets/user/images/cash.svg";
import CreditCardImg from "../../../assets/user/images/CreditCard.svg";
import ChequeImg from "../../../assets/user/images/cheque.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FileImg from "../../../assets/provider/images/file.jpg";
import { routes } from "../../../utlis/user/routes.utlis";
import toast from "react-hot-toast";
import { api } from "../../../utlis/user/api.utlis";
import ApiService from "../../../core/services/ApiService";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import Loader from "../../../layouts/loader/Loader";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { SingleFile } from "../../../utlis/common.utlis";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "react-bootstrap";
import DatePicker from "react-datepicker";
import uploadImage from "../../../assets/admin/images/uploadImage.svg";
import moment from "moment";
import { decode } from "base-64";
import InputMask from "react-input-mask";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";

const Edit = () => {
  const options = [];
  const navigate = useNavigate();
  const [list, setCategoryList] = useState([]);
  const [cardList, setCardList] = useState([]);
  const [detail, setDetail] = useState();
  const [cardIdErr, setCardIdErr] = useState(false);
  const [bankErr, setBankErr] = useState(false);
  const [chequeNumErr, setChequeNumErr] = useState(false);
  const [accountNumErr, setAccountNumErr] = useState(false);
  const [addCard, setAddCard] = useState(false);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(null);
  const localData = useLocation();
  const id = localData.state?.id;

  const getExpenseDetail = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      setDetail(response.data.data);
    } else {
      setDetail();
    }
    setLoading(false);
  };

  const initialValues = {
    title: detail?.title ?? "",
    category_id: detail?.category_id ?? "",
    description: detail?.description ?? "",
    expense_date: detail?.expense_date ?? "",
    amount: detail?.amount ?? "",
    is_recurring: detail?.is_recurring ?? 0,
    type: "M",
    expense_image: "",
    payment_type: detail?.payment_type ?? "",
    payment_type_id: detail?.payment_type_id ?? "",
    card_name: detail?.card_name ?? "",
    account_number: detail?.account_number ?? "",
    bank_name: detail?.bank_name ?? "",
  };

  const initialValuesCard = {
    card_no: "",
    card_type: "",
    name_on_card: "",
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required!"),
    category_id: Yup.string().required("Category is required!"),
    description: Yup.string().required("Description is required!"),
    amount: Yup.string().required("Amount is required!"),
    type: Yup.string().required("Type is required!"),
    expense_image: Yup.mixed()
      .test(
        "fileSize",
        `File size must be less than ${SingleFile} MB`,
        (value) => !value || (value && value.size <= SingleFile * 1024 * 1024)
      )
      .test("fileType", "Unsupported file type", (value) => {
        return value != "" && (value != null) & (value != undefined)
          ? ["image/jpeg", "image/png", "image/jpg"].includes(value.type)
          : true;
      }),
    payment_type: Yup.string().required("Payment type is required!"),
    payment_type_id: Yup.number()
      .nullable() // helps if the field starts empty
      .when("payment_type", (payment_type, schema) => {
        return payment_type === "Card"
          ? schema.required("Please select a card")
          : schema.notRequired();
      }),
  });

  const validationSchemaCard = Yup.object().shape({
    card_no: Yup.string()
      .min(19, "Card number is invalid")
      .required("Card number is required!"),
    card_type: Yup.string().required("Card type is required!"),
    name_on_card: Yup.string().required("Name is required!"),
  });

  const checkErr = (valu) => {
    const isFilled = (selector) => {
      const el = document.querySelector(selector);
      return el && el.value?.trim() !== "";
    };
    const isChecked = (selector) => {
      return document.querySelector(selector) !== null;
    };
    setCardIdErr(false);
    setChequeNumErr(false);
    setBankErr(false);
    setAccountNumErr(false);
    if (valu === "Card") {
      setCardIdErr(!isChecked('[name="payment_type_id"]:checked'));
    } else if (valu === "Cheque") {
      setChequeNumErr(!isFilled('[name="card_name"]'));
      setBankErr(!isFilled('[name="bank_name"]'));
      setAccountNumErr(!isFilled('[name="account_number"]'));
    }
  };

  const getCategoryList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("category listing => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setCategoryList(response.data.data.categories);
    } else setCategoryList([]);
    setLoading(false);
  };

  const getCardList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("card listing => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setCardList(response.data.data);
    } else setCardList([]);
    setLoading(false);
  };

  const editExpense = async (formValue) => {
    if (cardIdErr || chequeNumErr || bankErr || accountNumErr) {
      return;
    }
    setLoading(true);
    let form = new FormData();
    form.append("title", formValue.title);
    form.append("description", formValue.description);
    form.append("category_id", formValue.category_id);
    form.append("type", formValue.type);
    form.append("payment_type", formValue.payment_type);
    form.append("amount", formValue.amount);
    form.append("is_recurring", formValue.is_recurring ?? 0);
    if (formValue.payment_type == "Cheque") {
      form.append("card_name", formValue.card_name);
      form.append("account_number", formValue.account_number);
      form.append("bank_name", formValue.bank_name);
    }
    if (formValue.payment_type == "Card") {
      form.append("payment_type_id", formValue.payment_type_id);
    }
    form.append("expense_image", formValue.expense_image);
    const response = await ApiService.putAPIWithAccessTokenMultiPart(
      api.editExpense + `${decode(id)}`,
      form
    );
    if (response.data.status) {
      toast.success(response.data.message);
      navigate(routes.expenseDashboard);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const addCategory = async () => {
    if (name == null || name == "" || name == undefined)
      return toast.error("Category name is required!");
    setLoading(true);
    let form = new FormData();
    form.append("name", name);
    const response = await ApiService.postAPIWithAccessTokenMultiPart(
      api.addCategory,
      form
    );
    setName(null);
    document.getElementById("cate_name").value = "";
    if (response.data.status) {
      toast.success(response.data.message);
      getCategoryList(api.categoryListing);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const addNewCard = async (formValue) => {
    setLoading(true);
    const form = JSON.stringify({
      card_no: formValue.card_no,
      card_type: formValue.card_type,
      name_on_card: formValue.name_on_card,
    });
    const response = await ApiService.postAPIWithAccessToken(api.addCard, form);
    setAddCard(false);
    if (response.data.status) {
      toast.success(response.data.message);
      getCardList(api.cardListing);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getCategoryList(api.categoryListing);
    getCardList(api.cardListing);
    getExpenseDetail(api.detailsExpense + `${decode(id)}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container">
        <div className="care-expenses-section">
          <div className="expenses-title-header">
            <h2 className="heading-title">Edit Expense</h2>
            <div className="search-filter">
              <div className="row g-2">
                <div className="col-md-12">
                  <Link className="btn-gr" to="" onClick={() => navigate(-1)}>
                    Back
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="new-expenses-content">
            <Formik
              initialValues={initialValues}
              validateOnChange={true}
              validationSchema={validationSchema}
              onSubmit={editExpense}
              enableReinitialize
            >
              {({ values, setFieldValue }) => (
                <Form>
                  <div className="new-expenses-form">
                    <div className="new-expenses-card">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <h4>Expense Name</h4>
                            <Field
                              type="text"
                              className="form-control"
                              name="title"
                              placeholder="Enter Title"
                            />
                            <ErrorMessage
                              name="title"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <h4>Select Date</h4>
                            <Field name="expense_date" className="form-control">
                              {({ field }) => (
                                <DatePicker
                                  {...field}
                                  maxDate={new Date()}
                                  selected={values.expense_date || ""}
                                  disabled
                                  onChange={(value) =>
                                    setFieldValue("expense_date", value)
                                  }
                                  showIcon
                                  dateFormat={"MM-dd-yyyy"}
                                  className="form-control"
                                  style={{ padding: "15px 40px" }}
                                  autoComplete="off"
                                  placeholderText="Select Date"
                                />
                              )}
                            </Field>
                            <ErrorMessage
                              name="expense_date"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group search-form-group mb-1">
                            <h4>Expense Amount</h4>
                            <Field
                              type="number"
                              className="form-control"
                              name="amount"
                              placeholder="Enter Amount"
                            />
                            <span className="form-group-icon">
                              <img src={DollarImg} />
                            </span>
                          </div>
                          <ErrorMessage
                            name="amount"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <h4>Description</h4>
                            <Field
                              type="text"
                              as="textarea"
                              className="form-control"
                              name="description"
                              placeholder="Enter Description"
                            />
                            <ErrorMessage
                              name="description"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="new-expenses-card">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <h4>Expense Categories</h4>
                            <div className="choosepayment-list">
                              <ul>
                                {list.length !== 0
                                  ? list.map((ele, indx) => {
                                      return (
                                        <li key={indx} className="me-1">
                                          <div className="choosecategoriesradio">
                                            <Field
                                              type="radio"
                                              name="category_id"
                                              id={`${ele.id}_categories`}
                                              value={ele.id}
                                            />
                                            <label
                                              htmlFor={`${ele.id}_categories`}
                                            >
                                              <div className="categories-card">
                                                <div className="categories-text">
                                                  {ele.name ?? "NA"}
                                                </div>
                                              </div>
                                            </label>
                                          </div>
                                        </li>
                                      );
                                    })
                                  : null}
                              </ul>
                              <ErrorMessage
                                name="category_id"
                                component="div"
                                className="alert alert-danger"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-7">
                          <div className="ordivider">
                            <span>Or</span>
                          </div>
                        </div>
                      </div>
                      <div className="row w-50">
                        <div className="col-md-10">
                          <div className="form-group">
                            <h4>Add New Expense Category</h4>
                            <input
                              onChange={(e) => setName(e.target.value)}
                              id="cate_name"
                              type="text"
                              className="form-control"
                              name=""
                              placeholder="Enter category name"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group mt-4">
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                addCategory();
                              }}
                              type="button"
                              className="btn-gr w-100"
                            >
                              Add
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="new-expenses-card">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <h4>Enter Payment Method</h4>
                            <div className="choosepayment-list">
                              <ul>
                                <li>
                                  <div className="choosepaymentradio">
                                    <Field
                                      type="radio"
                                      name="payment_type"
                                      id="Card"
                                      value="Card"
                                    />
                                    <label for="Card">
                                      <div className="payment-method-card">
                                        <div className="payment-method-icon">
                                          <img src={CreditCardImg} />
                                        </div>
                                        <div className="payment-method-text">
                                          Card
                                        </div>
                                      </div>
                                    </label>
                                  </div>
                                </li>
                                <li className="mx-1">
                                  <div className="choosepaymentradio">
                                    <Field
                                      type="radio"
                                      name="payment_type"
                                      id="Cash"
                                      value="Cash"
                                    />
                                    <label for="Cash">
                                      <div className="payment-method-card">
                                        <div className="payment-method-icon">
                                          <img src={CashImg} />
                                        </div>
                                        <div className="payment-method-text">
                                          Cash
                                        </div>
                                      </div>
                                    </label>
                                  </div>
                                </li>
                                <li>
                                  <div className="choosepaymentradio">
                                    <Field
                                      type="radio"
                                      name="payment_type"
                                      id="Cheque"
                                      value="Cheque"
                                    />
                                    <label for="Cheque">
                                      <div className="payment-method-card">
                                        <div className="payment-method-icon">
                                          <img src={ChequeImg} />
                                        </div>
                                        <div className="payment-method-text">
                                          Cheque
                                        </div>
                                      </div>
                                    </label>
                                  </div>
                                </li>
                              </ul>
                              <ErrorMessage
                                name="payment_type"
                                component="div"
                                className="alert alert-danger"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {values.payment_type == "Cheque" ? (
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <h4>Cheque Number</h4>
                            <Field name="card_name">
                              {({ field, form }) => (
                                <InputMask
                                  {...field}
                                  mask="999999"
                                  className="form-control"
                                  maskChar=""
                                  onChange={(e) => {
                                    setFieldValue(field.name, e.target.value);
                                    checkErr(form.values.payment_type);
                                  }}
                                  placeholder="Enter Cheque Number"
                                />
                              )}
                            </Field>
                            {chequeNumErr && (
                              <div className="alert alert-danger">
                                Cheque number is required
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <h4>Account Number</h4>
                            <Field name="account_number">
                              {({ field, form }) => (
                                <InputMask
                                  {...field}
                                  mask="999999999999"
                                  className="form-control"
                                  maskChar=""
                                  onChange={(e) => {
                                    setFieldValue(field.name, e.target.value);
                                    checkErr(form.values.payment_type);
                                  }}
                                  placeholder="Enter Account Number"
                                />
                              )}
                            </Field>
                            {accountNumErr && (
                              <div className="alert alert-danger">
                                Account number is required
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <h4>Bank Name</h4>
                            <Field name="bank_name">
                              {({ field, form }) => (
                                <input
                                  {...field}
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Bank Name"
                                  onChange={(e) => {
                                    form.setFieldValue(
                                      field.name,
                                      e.target.value
                                    );
                                    checkErr(form.values.payment_type);
                                  }}
                                  onBlur={field.onBlur}
                                />
                              )}
                            </Field>
                            {bankErr && (
                              <div className="alert alert-danger">
                                Bank name is required
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {values.payment_type == "Card" ? (
                      <div>
                        <div className="col-md-2">
                          <button
                            onClick={() => setAddCard(true)}
                            type="button"
                            className="btn-gr mb-3"
                          >
                            Add New Card
                          </button>
                        </div>
                        {cardList.length !== 0 ? (
                          <div className="ordivider col-md-7">
                            <span>Or</span>
                          </div>
                        ) : null}
                        <div className="choosepayment-list mb-3">
                          <ul>
                            {cardList.length !== 0
                              ? cardList.map((ele, indx) => {
                                  return (
                                    <li key={indx} className="me-1">
                                      <div className="choosecategoriesradio">
                                        <Field name="payment_type_id">
                                          {({ field, form }) => (
                                            <input
                                              {...field}
                                              type="radio"
                                              id={`${ele.id}cardId`}
                                              value={`${ele.id}`}
                                              checked={
                                                values.payment_type_id == ele.id
                                              }
                                              onChange={(e) => {
                                                form.setFieldValue(
                                                  field.name,
                                                  e.target.value
                                                );
                                                checkErr(
                                                  form.values.payment_type
                                                );
                                              }}
                                            />
                                          )}
                                        </Field>
                                        <label htmlFor={`${ele.id}cardId`}>
                                          <div className="categories-card">
                                            <div className="categories-text">
                                              XXXX XXXX XXXX{" "}
                                              {ele.card_no
                                                ? ele.card_no.substr(
                                                    ele.card_no.length - 4
                                                  )
                                                : "NA"}
                                            </div>
                                            <div className="categories-text">
                                              {ele.card_type ?? "NA"}
                                            </div>
                                          </div>
                                        </label>
                                      </div>
                                    </li>
                                  );
                                })
                              : null}
                          </ul>
                          {cardIdErr && (
                            <div className="alert alert-danger">
                              Please select any card
                            </div>
                          )}
                        </div>
                      </div>
                    ) : null}

                    <div className="new-expenses-card">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <div className="upload-signature">
                              <h4>Upload Expense Images</h4>
                              <Field name="expense_image">
                                {({ field, form }) => (
                                  <>
                                    <input
                                      type="file"
                                      hidden
                                      id="files"
                                      accept="image/jpg, image/jpeg, image/png"
                                      className="form-control addsignature todo-list-input"
                                      onChange={(event) =>
                                        setFieldValue(
                                          "expense_image",
                                          event.currentTarget.files[0]
                                        )
                                      }
                                    />
                                    <label for="files">
                                      <div className="signature-text">
                                        <span>
                                          <img src={uploadImage} alt="" />
                                          <small className="prev-filename">
                                            {values?.expense_image?.name
                                              ? values?.expense_image?.name
                                              : "Click here to Upload Image"}
                                          </small>
                                        </span>
                                      </div>
                                    </label>
                                  </>
                                )}
                              </Field>
                              <ErrorMessage
                                name="expense_image"
                                component="div"
                                className="alert alert-danger"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {detail?.image != "" &&
                        detail?.image != null &&
                        detail?.image != undefined && (
                          <div className="mb-2">
                            <img
                              id="imagePreview"
                              src={detail?.image}
                              alt="Image Preview"
                              className="img-thumbnail"
                              style={{ maxWidth: "200px", maxHeight: "200px" }}
                            ></img>
                          </div>
                        )}
                    </div>
                    <div className="new-expenses-card">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <div className="cecheckbox">
                              <Field
                                type="checkbox"
                                id="Mark As Recurring Expense"
                                name="is_recurring"
                                value="1"
                                checked={detail?.is_recurring ?? 0}
                              />
                              <label for="Mark As Recurring Expense">
                                Mark As Recurring Expense
                              </label>
                            </div>
                            <ErrorMessage
                              name="image"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="new-expenses-card">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <button className="btn-bl" type="button">
                              Clear All
                            </button>
                            <button
                              onClick={(e) => {
                                checkErr(values.payment_type);
                              }}
                              type="submit"
                              className="btn-gr mx-1"
                            >
                              Update
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>

        <Modal
          show={addCard}
          onHide={() => {
            setAddCard(false);
          }}
          className=""
        >
          <div className="modal-content">
            <ModalHeader>
              <h5 className="mb-0">Add New Card</h5>
            </ModalHeader>
            <ModalBody className="">
              <div className="add-items d-flex row">
                <Formik
                  initialValues={initialValuesCard}
                  validateOnChange={true}
                  validationSchema={validationSchemaCard}
                  onSubmit={addNewCard}
                  enableReinitialize
                >
                  {({ values, setFieldValue }) => (
                    <Form className="findcare-form">
                      <div className="findcare-card row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <h4>Name on Card</h4>
                            <Field
                              type="text"
                              className="form-control"
                              name="name_on_card"
                              placeholder="Enter Name"
                            />
                            <ErrorMessage
                              name="name_on_card"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <h4>Card Number</h4>
                            <Field name="card_no">
                              {({ field }) => (
                                <InputMask
                                  {...field}
                                  mask="9999 9999 9999 9999"
                                  className="form-control"
                                  maskChar=""
                                  onChange={(e) => {
                                    setFieldValue(field.name, e.target.value);
                                  }}
                                  placeholder="Enter Card Number"
                                />
                              )}
                            </Field>
                            <ErrorMessage
                              name="card_no"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group mb-1">
                            <h4>Card Type</h4>
                            <Field
                              as="select"
                              type="text"
                              className="form-control"
                              name="card_type"
                            >
                              <option value="">Select Card Type</option>
                              <option value="Visa">Visa</option>
                              <option value="Mastercard">Mastercard</option>
                              <option value="Other">Other</option>
                            </Field>
                          </div>
                          <ErrorMessage
                            name="card_type"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                        <div className="form-group text-end mt-3">
                          <button
                            type="button"
                            onClick={() => {
                              setAddCard(false);
                            }}
                            className="btn btn-re me-2"
                            data-bs-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="btn btn-gr me-2"
                            data-bs-dismiss="modal"
                          >
                            Add
                          </button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </ModalBody>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default Edit;
